import ApiBase from '../ApiBase';

class SiteConfig extends ApiBase {
    route = 'admin/site-config';
}

export default new SiteConfig();
